export default __webpack_public_path__ + "static/media/car_dark.b4ef030b.png";